import { render, staticRenderFns } from "./TeacherClassForm.vue?vue&type=template&id=514b2a3a"
import script from "./TeacherClassForm.vue?vue&type=script&lang=js"
export * from "./TeacherClassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('514b2a3a')) {
      api.createRecord('514b2a3a', component.options)
    } else {
      api.reload('514b2a3a', component.options)
    }
    module.hot.accept("./TeacherClassForm.vue?vue&type=template&id=514b2a3a", function () {
      api.rerender('514b2a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/teacherClass/modules/TeacherClassForm.vue"
export default component.exports